import type { MouseEvent, ReactNode } from 'react'
import { SUPPORT_SMS_HREF, canTextFromThisDevice } from '../lib/contact'
import { useChatWidget } from '../hooks/useChatWidget'

interface TextUsLinkProps {
  className?: string
  children: ReactNode
  /** Runs first on every click - analytics, closing a menu. */
  onClick?: () => void
}

/**
 * The one way to present the support number on this site (issue #79).
 *
 * The line takes texts, not calls, so this is an sms: link. On a phone that
 * opens the messaging app with the number already filled in. On a laptop
 * there is nothing to text from, so rather than a link that does nothing it
 * opens the live chat instead - which is also where the auto-reply to a text
 * points people, so both routes end up in the same place.
 *
 * Kept as a real <a href="sms:..."> rather than a button so it still works
 * with JavaScript off, can be copied, and is correct to a screen reader.
 */
export function TextUsLink({ className, children, onClick }: TextUsLinkProps) {
  const { open } = useChatWidget()

  function handleClick(e: MouseEvent<HTMLAnchorElement>) {
    onClick?.()
    if (!canTextFromThisDevice()) {
      e.preventDefault()
      open()
    }
  }

  return (
    <a href={SUPPORT_SMS_HREF} onClick={handleClick} className={className}>
      {children}
    </a>
  )
}
